import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of, switchMap } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  getAllDealStatsAction,
  getAllDealStatsFailureAction,
  getAllDealStatsSuccessAction
} from './get-all-deal-stats.actions';
import { GetAllDealStatsService } from './get-all-deal-stats.service';

@Injectable()
export class GetAllDealStatsEffects {
  getAllDealStats$ = createEffect(() => this.actions$.pipe(
    ofType(getAllDealStatsAction),
    switchMap(action =>
      this.getAllDealStatsService.get(action.payload).pipe(
        map(data => getAllDealStatsSuccessAction({ data })),
        catchError(error => of(getAllDealStatsFailureAction({ error }))),
      )
    )
  ));

  constructor(
    private actions$: Actions,
    private getAllDealStatsService: GetAllDealStatsService,
  ) {
  }
}
